import React, { useContext, useMemo, useState } from 'react'
import { Field, Form, Formik, } from 'formik';
import RangeSlider from "react-range-slider-input";

const FinanceCalculatorForm = () => {
    const [priceFilterData, setPriceFilterData] = useState({ 'min': 0, 'max': 20, 'current_value': 20 });
    const [rangeData, setRangeData] = useState([0, 20]);
    const [loanTermData, setLoanTermData] = useState({ 'min': 0, 'max': 8, 'current_value': 8 });
    const [loanTermRange, setLoanTermRange] = useState([0, 8]);
    const calcMonthlyPayment = (principal = 0, annualRatePct = 0, termYears = 0) => {
        if (!principal || !termYears) return 0;

        const n = termYears * 12;                    // total payments
        const i = (annualRatePct / 100) / 12;        // monthly rate

        // Zero-interest loan?  Simple division.
        if (i === 0) return principal / n;

        const factor = Math.pow(1 + i, n);
        return principal * (i * factor) / (factor - 1);
    };
    return (
        <>
            <Formik
                initialValues={{
                    loan_amount: '',
                    interest_rate: priceFilterData.current_value || '',
                    loan_term: loanTermData.current_value || '',
                }}
                onSubmit={async (values, { resetForm }) => {
                    console.log(values);
                    // resetForm();
                }}
            >
                {({ values, setFieldValue }) => {
                    const handleSliderChange = (value) => {
                        setRangeData(value);
                        setPriceFilterData((prev) => ({
                            ...prev,
                            current_value: value[1],
                        }));
                        setFieldValue('interest_rate', value[1]);
                    };

                    const handleTermSliderChange = (value) => {
                        setLoanTermRange(value);
                        setLoanTermData((prev) => ({
                            ...prev,
                            current_value: value[1],
                        }));
                        setFieldValue('loan_term', value[1]);
                    };

                    // Simple inline calculation
                    const principal = Number(values.loan_amount) || 0;
                    const annualRate = Number(values.interest_rate) || 0;
                    const termYears = Number(values.loan_term) || 0;

                    const totalMonths = termYears * 12;
                    const monthlyRate = annualRate / 100 / 12;
                    const payment =
                        monthlyRate === 0
                            ? principal / totalMonths || 0
                            : (principal * monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) /
                            (Math.pow(1 + monthlyRate, totalMonths) - 1);

                    const formattedPayment = isFinite(payment)
                        ? `$${payment.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}`
                        : '--';
                    return (
                        <Form className="custom-form finance-calculator-form" autoComplete="off" name="order-part-form">
                            <div className='form-group mb-5'>
                                <div className='cs-label font-1em mb-1'>Loan Amount</div>
                                <Field name="loan_amount">
                                    {({ field, form }) => {
                                        const rawValue = field.value?.replace(/[^\d]/g, '') || ''; // Only digits
                                        const formattedValue = rawValue ? `$${Number(rawValue).toLocaleString()}` : '';

                                        return (
                                            <input
                                                type="text"
                                                {...field}
                                                className="pr-input-field w-100 text-start"
                                                value={formattedValue}
                                                onChange={(e) => {
                                                    const inputVal = e.target.value.replace(/[^\d]/g, ''); // Strip non-numeric
                                                    form.setFieldValue('loan_amount', inputVal);
                                                }}
                                            />
                                        );
                                    }}
                                </Field>
                            </div>
                            <div className='form-group'>
                                <div className='d-flex align-items-center justify-content-between mb-2'>
                                    <div className='xs-title font-1em mb-0'>Interest Rate</div>
                                    <Field
                                        type="text"
                                        name="interest_rate"
                                        className="pr-input-field text-center w-150px"
                                        value={`${values.interest_rate}%`}
                                        readOnly
                                    />
                                </div>
                                <div className='price-range-slider'>
                                    <RangeSlider
                                        className="single-thumb"
                                        value={rangeData}
                                        onInput={handleSliderChange}
                                        thumbsDisabled={[true, false]}
                                        rangeSlideDisabled={true}
                                        min={priceFilterData.min}
                                        max={priceFilterData.max}

                                    />
                                    <div className='d-flex align-items-center justify-content-between pr-labels'>
                                        <div>{`${priceFilterData.min}%`}</div>
                                        <div>{`${priceFilterData.max}%`}</div>
                                    </div>
                                </div>
                            </div>
                            <div className='form-group'>
                                <div className='d-flex align-items-center justify-content-between mb-2'>
                                    <div className='xs-title font-1em mb-0'>Loan Term</div>
                                    <Field
                                        type="text"
                                        name="interest_rate"
                                        className="pr-input-field text-center w-150px"
                                        value={`${values.loan_term} yr`}
                                        readOnly
                                    />
                                </div>
                                <div className='price-range-slider'>
                                    <RangeSlider
                                        className="single-thumb"
                                        value={loanTermRange}
                                        onInput={handleTermSliderChange}
                                        thumbsDisabled={[true, false]}
                                        rangeSlideDisabled={true}
                                        min={loanTermData.min}
                                        max={loanTermData.max}
                                    />
                                    <div className='d-flex align-items-center justify-content-between pr-labels'>
                                        <div>{`${loanTermData.min}yr`}</div>
                                        <div>{`${loanTermData.max}yr`}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between mt-80">
                                <div className="xs-title">Estimated Monthly Payment</div>
                                <div className="lg-title fw-700">{formattedPayment}</div>
                            </div>
                        </Form>
                    )
                }}
            </Formik>
        </>
    )
}

export default FinanceCalculatorForm